export const PRESET_IDS = [
  "videobackground1",
  "videobackground2",
  "videobackground3",
  "videobackground4",
  "videobackground5",
  "videobackground6",
  "videobackground7",
  "videobackground8",
  "videobackground9",
  "videobackground10",
] as const;

export type PresetId = (typeof PRESET_IDS)[number];

export const BACKGROUND_PRESETS: { id: PresetId; src: string }[] = [
  {
    id: "videobackground1",
    src: `${import.meta.env.BASE_URL}vbg1new.jpg`,
  },
  {
    id: "videobackground2",
    src: `${import.meta.env.BASE_URL}vbg1_1new.jpg`,
  },
  {
    id: "videobackground3",
    src: `${import.meta.env.BASE_URL}vbg2.jpg`,
  },
  {
    id: "videobackground4",
    src: `${import.meta.env.BASE_URL}vbg3.jpg`,
  },
  {
    id: "videobackground5",
    src: `${import.meta.env.BASE_URL}vbg4.jpg`,
  },
  {
    id: "videobackground6",
    src: `${import.meta.env.BASE_URL}vbg5.jpg`,
  },
  {
    id: "videobackground7",
    src: `${import.meta.env.BASE_URL}vbg6.jpg`,
  },
  {
    id: "videobackground8",
    src: `${import.meta.env.BASE_URL}vbg7.jpg`,
  },
  {
    id: "videobackground9",
    src: `${import.meta.env.BASE_URL}vbg8.jpg`,
  },
  {
    id: "videobackground10",
    src: `${import.meta.env.BASE_URL}vbg9.jpg`,
  },
];
